import { currentYear } from "../../context/constants";
import { Col, Row } from "react-bootstrap";
const Footer = () => {
    return (
        <footer className="footer">
            <div className="page-container">
                <Row>
                    <Col
                        md={6}
                        className="text-center text-md-start"
                    >
                        {currentYear} © {" "}
                        <span className="fw-bold text-decoration-underline text-uppercase text-reset fs-12">
                        ilmaivo
                        </span>
                    </Col>
                    <Col md={6}>
                        {/* <div className="text-md-end footer-links d-none d-md-block">
                            <Link to="">About</Link>
                            <Link to="">Support</Link>
                            <Link to="">Contact Us</Link>
                        </div> */}
                    </Col>
                </Row>
            </div>
        </footer>
    );
};
export default Footer;
